// Pre-populated list of TCHA services offered, shown in the invoice line item dropdown.
export const SERVICE_OPTIONS = [
  'Advance MLD - 4 day CEU program',
  'Brazilian MLD',
  'Cupping Therapy',
  'Gua-Sha Techniques',
  'Hot Bamboo Massage Techniques',
  'Hot-Stone Techniques',
  'IASTM',
  'Indie Head Massage',
  'K-Tapping Techniques',
  'MLD Level 1',
  'MLD Level 2',
  'Myofacia Stretch & Release Techniques',
  'Relaxation Massage Techniques',
  'Swedish Relaxation Massage',
];
